<!--
 * @Author: Admni
 * @Description: 等待列表
 * @Date: 2021-01-29 14:28:30
 * @LastEditTime: 2021-03-03 10:54:16
-->
<template>
  <div id="wait">
    <h1>
      <span>等待列表</span>
      <small>所有待分配会话,可将会话分配到等待队列</small>
    </h1>
    <section class="search">
      <el-form :inline="true" class="search-form" label-width="80px">
        <el-row>
          <el-form-item label="版本">
            <el-input
              v-model="form.ver"
              style="width: 260px"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="用户类型">
            <el-select
              v-model="form.u_level"
              style="width: 260px"
              placeholder="请选择"
            >
              <el-option
                v-for="item in optionLevel"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="国家">
            <el-input
              v-model="form.ctr"
              style="width: 260px"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="手机国家">
            <el-input
              v-model="form.s_ctr"
              style="width: 260px"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="用户名">
            <el-input
              v-model="form.u"
              style="width: 260px"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="Tag">
            <el-select
              v-model="form.tag"
              multiple
              collapse-tags
              style="width: 260px"
              placeholder="请选择（默认所有）"
            >
              <el-option
                v-for="item in optionTag"
                :key="item.pk"
                :label="item.name"
                :value="item.pk"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="包名">
            <el-select
              v-model="form.pkg"
              multiple
              collapse-tags
              style="width: 260px"
              placeholder="请选择（默认所有）"
            >
              <el-option
                v-for="item in optionsPkg"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期范围">
            <el-date-picker
              v-model="form.date"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期(默认七天)"
              end-placeholder="结束日期(默认七天)"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit" icon="el-icon-search"
              >搜索</el-button
            >
            <el-button
              type="primary"
              @click="reset"
              icon="el-icon-refresh-right"
              >重置</el-button
            >
          </el-form-item>
        </el-row>
      </el-form>
    </section>

    <div class="table-wrap">
      <el-table
        :data="tableData"
        style="width: 100%"
        v-loading="loading"
        border
        :header-cell-style="{ background: '#ececf1', color: '#414750' }"
      >
        <el-table-column
          align="center"
          prop="pkg__group"
          label="组别"
          width="100"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="create_time"
          label="反馈时间"
          width="200"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="pkg__pkg"
          label="包名"
          width="240"
        >
        </el-table-column>
        <el-table-column align="center" label="操作系统">
          <template slot-scope="scope">
            <span>{{ scope.row.pkg__os === 1 ? "Android" : "Ios" }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="ver" label="版本">
        </el-table-column>
        <el-table-column align="center" prop="u_name" label="反馈用户">
        </el-table-column>
        <el-table-column align="center" prop="ctr" label="国家">
        </el-table-column>
        <el-table-column align="center" fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button @click="distribution(scope.row)" type="text" size="small"
              >分配会话</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="pages">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="1000"
          @current-change="changeCurrent"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getDisList, getChatToOur } from "@/api/chat.js";
export default {
  name: "wait-list",
  data() {
    return {
      loading: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      optionsPkg: [],
      optionTag: [],
      form: {
        pkg: [],
        ver: "",
        u: "",
        u_level: "",
        ctr: "",
        s_ctr: "",
        tag: [],
        date: [],
      },
      page: 0,
      curVal: {},
      tableData: [],
      optionLevel: [
        {
          label: "免费",
          value: 0,
        },
        {
          label: "付费",
          value: 1,
        },
      ],
    };
  },
  mounted() {
    let _group = JSON.parse(localStorage.getItem("pkg"));
    let resList = [];
    _group.forEach((gVal) => {
      resList.push({
        value: gVal.pkg,
        label: gVal.pkg,
      });
    });
    this.optionsPkg = resList;

    let _localTags = JSON.parse(localStorage.getItem("tag")).tags;
    let tList = [];
    _localTags.forEach((tVal) => {
      tList.push({
        pk: tVal.pk,
        name: tVal.name,
      });
    });
    this.optionTag = tList;

    this.getData();
  },
  methods: {
    getData() {
      let params = JSON.parse(JSON.stringify(this.form));
      delete params.date;
      params.pkg = this.form.pkg.join(",");
      params.tag = this.form.tag.join(",");
      params.st =
        this.form.date && this.form.date.length > 0 ? this.form.date[0] : "";
      params.et =
        this.form.date && this.form.date.length > 0 ? this.form.date[1] : "";
      params.left = this.page;
      this.loading = true;

      getDisList(params)
        .then((res) => {
          this.tableData = res.list;
          this.loading = false;
        })
        .catch((err) => {
          this.$message({
            message: err,
            type: "warning",
          });
          this.loading = false;
        });
    },
    onSubmit() {
      this.getData();
    },
    reset() {
      this.form = this.$options.data.call(this).form;
      this.getData();
    },
    changeCurrent(val) {
      this.page = val - 1;
      this.getData();
    },
    distribution(val) {
      let params = {
        pkg: val.pkg__pkg,
        u_id: val.user,
      };
      getChatToOur(params).then((res) => {
        if (res.result) {
          this.$message({
            message: "分配成功",
            type: "success",
          });
          this.getData();
        } else {
          this.$message({
            message: "分配失败",
            type: "warning",
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#wait {
  width: 100%;
  min-height: calc(100vh - 50px);
  padding: 20px;
  background: #eff1f7;
}
h1 {
  font-size: 20px;
  font-weight: 400;
  small {
    margin-left: 15px;
    font-size: 15px;
    color: #777777;
  }
}
.search {
  padding: 20px 20px 0;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  background: #ffffff;
}
.table-wrap {
  padding: 5px;
  margin-top: 20px;
  border: 1px solid #e4e4e4;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
  background: #ececf1;
}
.pages {
  display: flex;
  justify-content: flex-end;
  margin: 15px 0;
  width: 100%;
}
</style>
